// Who sees Admin Actions → Agent Settings. This only hides the menu item and
// guards the route; AgentSettingsController in dgtasks_api enforces the same
// list (AGENT_SETTINGS_ADMIN_EMAILS) on every request. Keep the two in step.
export const AGENT_SETTINGS_ADMIN_EMAILS = [
    'dillon@dgventureslimited.com',
    'aaron@dgventureslimited.com',
    'gammelldean@gmail.com',
    'daniza@stagit.ie',
    'dillongunn@gmail.com',
]

export function canManageAgentSettings(user) {
    const email = (user?.email || '').trim().toLowerCase()
    return AGENT_SETTINGS_ADMIN_EMAILS.includes(email)
}
